module.exports = __webpack_public_path__ + "img/960w.46db6e5.jpg";